export var staticPagesList = [];
export var announcementsList = [];
export var teamList = [];
export var helpList = [];
export var allIddaaList = [];
export var gameList = [];
